module.exports = __webpack_public_path__ + "images/macbook-ru-941402.png";